import common from './reducers/common'
import home from './reducers/home'
import auth from './reducers/auth'
import settings from './reducers/settings'
import cart from './reducers/cart'
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

export default combineReducers({
  common,
  home,
  auth,
  settings,
  cart,
  router: routerReducer
})
